/* Bootstrap */

// import "bootstrap";
// import { Modal } from 'bootstrap'

/* Custom SCSS */
// import "./index.scss";
// import './style-login.scss';
// import './style-admin.scss';
// import './style-buttons.scss';

/* Swiper */

import Swiper from "swiper";
// import Swiper, { Navigation, Pagination, Scrollbar } from "swiper";
import "swiper/css";
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';

// Swiper.use([Scrollbar]);
// init Swiper:

// import swiperSlider from "./js/swiperSlider";
// swiperSlider();

/* Fancybox */

// import { Fancybox } from "@fancyapps/ui";
// import "@fancyapps/ui/dist/fancybox.css";

/* Gsap */

// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger.js";
// gsap.registerPlugin(ScrollTrigger);

// var Isotope = require('isotope-layout');
// import fadeOnScreen from "./js/fadeOnScreen";
// fadeOnScreen();

import massimo from "./js/massimo";
massimo();

import navbar from "./js/navbar";
navbar();

import footer from "./js/footer";
footer();

import sidebar from "./js/sidebar";
sidebar();

import search from "./js/search";
search();



// import woocommerce from "./js/woocommerce";
// woocommerce();

import scrollTop from "./js/scrollTop";
scrollTop();
